import { goNext } from "../../../../redux/formActions";
import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { updateJoiningDetails } from "../../../../redux/slice/joiningDetailsSlice";
import { getExportData } from "../../../../redux/slice/getExportDataSlice";
import { toast, ToastContainer } from "react-toastify";
import { useDocumentUpload } from "../../../../hooks/useDocumentUpload";
import ValidateFile from "utils/ValidateFile";
import { setActiveMenu } from "../../../../redux/slice/activeMenuSlice";
import { fetchMyProfile } from "../../../../redux/slice/myProfileSlice";
import { getAllUploadedFile } from '../../../../redux/slice/filesUploadSlice';

const SUB_MENU_ORDER = ["personalDetails", "nomineeDetails", "insuranceDependentDetails", "bankDetails"];
const JoiningDetailsForm = () => {
  const dispatch = useDispatch();
  const [activeSubMenu, setActiveSubMenu] = useState("personalDetails");
  const isTesting = process.env.REACT_APP_ENABLE_ALL_STEPS === "true";
  const [maxStepReached, setMaxStepReached] = useState(
    isTesting ? 3 : 0
  );
  const [inputList, setInputList] = useState([
    { name: "", relationship: "", dob: "", phone: "" },
  ]);
  const [userName, setuserName] = useState(null);
  const aadhaarFileRef = useRef(null);
  const panFileRef = useRef(null);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    control,
    setError,
    trigger,
    clearErrors,
    formState: { errors },
  } = useForm({
    shouldUnregister: true,
    mode: "all", // This ensures validation happens on change AND on blur
    reValidateMode: "onChange",
    defaultValues: {
      maritalStatus: "false",
      spouseEmployment: "false",
      bloodGroup: "",
      insuranceDependentDetails: inputList,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "insuranceDependentDetails",
  });
  const { bankDetails, personalDetail, nomineeDetails, insuranceDependentDetails } = useSelector((state) => state?.Myprofile?.Myprofile ?? {});
  useSelector((state) => console.log('(state.Myprofile)', state.Myprofile.Myprofile));
  const InitialPermissionData = useSelector(
    (state) => state.persistedReducer.forms.savedPermissions,
  );
  const { allFiles, fetchAllStatus } = useSelector((state) => state.filesUpload);
  console.log('allFiles', allFiles)
  const { isExistingEmp, } = useSelector((state) => state?.persistedReducer?.forms?.savedPermissions) || {}
  const { userId } = InitialPermissionData ?? {};
  const {
    selectedFiles,
    uploadStatus,
    handleFileSelect,
    handleFileUpload,
    handleViewFile,
    resetAllUploads,
  } = useDocumentUpload({ candidateId: userId });
  const maritalStatusWatch = watch("maritalStatus");
  const isMarried = maritalStatusWatch === "Yes";

  const [hasNominee, setHasNominee] = useState(true);
  const [hasInsurance, setHasInsurance] = useState(true);
  const [hasBank, setHasBank] = useState(true);
  const [hasAadhaarCard, setHasAadhaarCard] = useState(false);
  const [hasPanCard, setHasPanCard] = useState(false);
  const [hasPassbookFrontImage, setHasPassbookFrontImage] = useState(false);
  const [hasCancelledCheque, setHasCancelledCheque] = useState(false);

  const passbookReg = register("passbookFrontImage", {
    required: !hasPassbookFrontImage ? "Passbook image is required" : false,
    validate: (files) => ValidateFile(files, ["image/jpg", "image/jpeg", "image/png"]),
  });
  const cancelledChequeReg = register("cancelledCheque", {
    required: !hasCancelledCheque ? "cancelled Cheque is required" : false,
    validate: (files) => ValidateFile(files, ["image/jpg", "image/jpeg", "image/png"]),
  });
  const ToggleCTA = ({ label, subText, checked, onChange, isExistingEmp }) => {
    return (
      <div className="toggle-container">
        <div>
          <label className="toggle-label">{label}</label>
          <small className="toggle-subtext">{subText}</small>
        </div>

        <div className="checkbox-wrapper-25">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
        </div>
      </div>
    );
  };
  const ToggleCTAExisting = ({ label, subText, checked, onChange, isExistingEmp }) => {
    return (
      <div className="toggle-container">
        <div>
          <label className="toggle-label">{label}</label>
          <small className="toggle-subtext">{subText}</small>
        </div>
      </div>
    );
  };
  useEffect(() => {

    if (personalDetail || nomineeDetails || insuranceDependentDetails || bankDetails) {


      const nominee = nomineeDetails?.[0] || {};


      const formattedInsurance = (insuranceDependentDetails || []).map((item) => ({
        name: item.name || "",
        relationship: item.relationship || "",
        dob: item.dob ? item.dob.split("T")[0] : "",
        gender: item.gender || "",
        age: item.age || "",
        phone: item.phone || "",
        amount: item.amount || "",
      }));

      reset({

        religion: personalDetail?.religion || "",
        bloodGroup: personalDetail?.bloodGroup || "",
        maritalStatus: personalDetail?.maritalStatus || "",
        employmentOfSpouse: personalDetail?.employmentOfSpouse || "",
        emergencyContactNumber: personalDetail?.emergencyContactNumber || "",

        nomineeName: nominee.nomineeName || "",
        relation: nominee.relation || "",
        dob: nominee.dob ? nominee.dob.split("T")[0] : "",
        address: nominee.address || "",
        aadhaarCardNumber: nominee.aadhaarNo || "",
        panCardNumber: nominee.panNo || "",


        bankName: bankDetails?.bankName || "",
        branchName: bankDetails?.branchName || "",
        accountNumber: bankDetails?.accountNumber ? String(bankDetails.accountNumber) : "",
        ifscCode: bankDetails?.ifscCode || "",
        accountHolderName: bankDetails?.accountHolderName || "",

        insuranceDependentDetails: formattedInsurance,
      });

      if (nominee.nomineeName) setHasNominee(true);
      if (formattedInsurance.length > 0) {
        setHasInsurance(true);
        setInputList(insuranceDependentDetails);
      }
      if (bankDetails?.bankName) setHasBank(true);
    }
  }, [personalDetail, nomineeDetails, insuranceDependentDetails, reset]);

  useEffect(() => {
    const getuserName = localStorage.getItem("name");
    if (getuserName) {
      const capitalizedUserName =
        getuserName.charAt(0).toUpperCase() + getuserName.slice(1);
      setuserName(capitalizedUserName);
      setValue("fullName", capitalizedUserName);
    }
  }, [setValue]);
  // to sync redux success with form errors
  useEffect(() => {
    const fileKeys = [
      "nomineeAadhaarCard",
      "nomineePanCard",
      "passbookFrontImage",
      "cancelledCheque",
    ];

    fileKeys.forEach((key) => {
      if (uploadStatus[key] === "succeeded") {
        clearErrors(key);
      }
    });
  }, [uploadStatus, clearErrors]);
  useEffect(() => {
    dispatch(fetchMyProfile());
    dispatch(getAllUploadedFile(userId));
  }, [activeSubMenu])
  useEffect(() => {
    setHasAadhaarCard(allFiles.some(doc => doc.fileType === "nomineeaadhaarcard"));

    setHasPanCard(allFiles.some(doc => doc.fileType === "nomineepancard"));

    setHasPassbookFrontImage(allFiles.some(doc => doc.fileType === "passbookfrontimage"));
    setHasCancelledCheque(allFiles.some(doc => doc.fileType === "cancelledcheque"));
  }, [activeSubMenu])

  // Clear file selections and upload statuses whenever the user switches tabs
  useEffect(() => {
    resetAllUploads();
    clearErrors();
  }, [activeSubMenu]);

  const relationshipOptions = [
    { label: "Father", value: "Father" },
    { label: "Mother", value: "Mother" },
    { label: "Spouse", value: "Spouse" },
    { label: "Son", value: "Son" },
    { label: "Daughter", value: "Daughter" },
    { label: "Other", value: "Other" }
  ];
  // relationsig dropdown
  const selectedRelationships = watch("insuranceDependentDetails") || [];
  const hasParent = selectedRelationships.some(
    (item) =>
      item?.relationship === "Father" || item?.relationship === "Mother"
  );
  const hasInLaw = selectedRelationships.some(
    (item) =>
      item?.relationship === "Father in law" ||
      item?.relationship === "Mother in law"
  );
  useEffect(() => {
    if (!selectedRelationships.length) return;
    selectedRelationships.forEach((item, index) => {
      if (
        hasParent &&
        (item?.relationship === "Father in law" ||
          item?.relationship === "Mother in law")
      ) { setValue(`insuranceDependentDetails.${index}.relationship`, ""); }

      if (hasInLaw && (item?.relationship === "Father" || item?.relationship === "Mother")) {
        setValue(`insuranceDependentDetails.${index}.relationship`, "");
      }
    });
  }, [selectedRelationships, hasParent, hasInLaw, setValue]);
  // relationsig dropdown end

  const handleAddClick = () => {
    const newList = [
      ...inputList,
      { name: "", relationship: "", dob: "", phone: "" },
    ];
    setInputList(newList);
    setValue(`insuranceDependentDetails.${newList.length - 1}`, {
      name: "",
      relationship: "",
      dob: "",
      phone: "",
    });
  };

  const handleRemove = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);

    const currentValues = getValues("insuranceDependentDetails");
    if (currentValues && Array.isArray(currentValues)) {
      const updatedValues = currentValues.filter((_, i) => i !== index);
      setValue("insuranceDependentDetails", updatedValues);
    }
  };

  const handleStepSubmit = async () => {
    let fieldsToValidate = [];

    // Define which fields belong to which step
    if (activeSubMenu === "personalDetails") {
      fieldsToValidate = [
        "religion",
        "bloodGroup",
        "maritalStatus",
        "employmentOfSpouse",
        "emergencyContactNumber",
      ];
    } else if (activeSubMenu === "nomineeDetails") {
      fieldsToValidate = [
        "nomineeName",
        "relation",
        "dob",
        "address",
        "aadhaarCardNumber",
        "panCardNumber",
        "nomineeAadhaarCard",
        "nomineePanCard",
      ];
    } else if (activeSubMenu === "insuranceDependentDetails") {
      fieldsToValidate = ["insuranceDependentDetails"];
    } else if (activeSubMenu === "bankDetails") {
      fieldsToValidate = [
        "bankName",
        "branchName",
        "accountNumber",
        "ifscCode",
        "accountHolderName",
        "passbookFrontImage",
        "cancelledCheque",
      ];
    }

    // Trigger validation for ONLY these fields
    const isStepValid = await trigger(fieldsToValidate);

    if (isStepValid) {
      const currentIndex = SUB_MENU_ORDER.indexOf(activeSubMenu);
      const nextIndex = currentIndex + 1;

      if (nextIndex > maxStepReached && nextIndex < SUB_MENU_ORDER.length) {
        setMaxStepReached(nextIndex);
      }
      // If valid, call your existing onSubmit with current values
      onSubmit(getValues());
    } else {
      toast.error("Validation failed for fields", fieldsToValidate);
    }
  };


  function onSubmit(data) {
    let payload = data;
    const normalizedActiveSubMenu = activeSubMenu.toUpperCase();
    // 1. Define Requirement Map
    const fileRequirements = {
      NOMINEEDETAILS: [
        {
          key: "nomineeAadhaarCard",
          name: "nomineeAadhaarCard",
          msg: "Please upload Aadhaar document",
          existing: hasAadhaarCard
        },
        { key: "nomineePanCard", name: "nomineePanCard", msg: "Please upload PAN document", existing: hasPanCard },
      ],
      BANKDETAILS: [
        {
          key: "passbookFrontImage",
          name: "passbookFrontImage",
          msg: "Please upload Passbook front image",
          existing: hasPassbookFrontImage
        },
        {
          key: "cancelledCheque",
          name: "cancelledCheque",
          msg: "Please upload Cancelled Cheque",
          existing: hasCancelledCheque
        },
      ],
    };

    // 2. Optimized Validation Loop
    const requirements = fileRequirements[normalizedActiveSubMenu] || [];
    let hasUploadError = false;

    requirements.forEach((req) => {
      const isUploaded = uploadStatus[req.key] === "succeeded";
      const isExisting = req.existing;

      if (isUploaded || isExisting) {
        clearErrors(req.name);
      } else {
        setError(req.name, { type: "manual", message: req.msg });
        hasUploadError = true;
      }
    });

    if (hasUploadError) return;
    if (normalizedActiveSubMenu === "PERSONALDETAILS") {
      const personalData = {
        religion: data.religion,
        bloodGroup: data.bloodGroup,
        maritalStatus: data.maritalStatus,
        employmentOfSpouse: data.employmentOfSpouse,
        emergencyContactNumber: data.emergencyContactNumber,
      };
      payload = personalData;
    } else if (normalizedActiveSubMenu === "INSURANCEDEPENDENTDETAILS") {
      const familyData = inputList.map((_, i) =>
        getValues(`insuranceDependentDetails.${i}`),
      );
      payload = { insuranceDependentDetails: familyData };
    } else if (normalizedActiveSubMenu === "NOMINEEDETAILS") {
      const nomineeData = {
        nomineeName: data.nomineeName,
        relation: data.relation,
        dob: data.dob,
        address: data.address,
        aadhaarNo: data.aadhaarCardNumber,
        panNo: data.panCardNumber,
        aadhaarUrl: "",
        panUrl: "",
      };
      payload = { nominees: [nomineeData] };
    } else if (normalizedActiveSubMenu === "BANKDETAILS") {
      const bankData = {
        bankSkip: false,
        bankName: data.bankName,
        branchName: data.branchName,
        accountNumber: data.accountNumber,
        ifscCode: data.ifscCode,
        accountHolderName: data.accountHolderName,
        passbookImageUrl: "",
        cancelledChequeUrl: "",
      };
      payload = { bankDetails: bankData };
    }
    dispatch(updateJoiningDetails({ userId, payload }));
    if (
      normalizedActiveSubMenu === "NOMINEEDETAILS" ||
      normalizedActiveSubMenu === "BANKDETAILS"
    ) {
      setTimeout(() => {
        resetAllUploads();
        reset();
      }, 100);
    } else {
      reset();
    }

    dispatch(goNext());
    if (activeSubMenu === "personalDetails") {
      setActiveSubMenu("nomineeDetails");
    } else if (activeSubMenu === "nomineeDetails") {
      setActiveSubMenu("insuranceDependentDetails");
    } else if (activeSubMenu === "insuranceDependentDetails") {
      setActiveSubMenu("bankDetails");
    }
    else if (activeSubMenu === "bankDetails") {
      if (isExistingEmp) {
        dispatch(setActiveMenu({ menu: 'uploaddocuments', subMenu: "summary" }));
      }
      else {
        dispatch(setActiveMenu({ menu: 'policies', subMenu: "summary" }));
      }

      console.log('activeSubMenu', activeSubMenu)
    }
  };
  const handleExport = async () => {

    try {
      const fileBlob = await dispatch(getExportData(userId)).unwrap();

      saveAs(fileBlob, 'Employees_Insurance_details.xlsx');

    } catch (error) {

      console.error("Export failed:", error);
    }

  };
  const today = new Date().toISOString().split("T")[0];
  // Age calculate function
  const calculateAge = (dob) => {
    if (!dob) return "";

    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  return (
    <div>
      <div className="subnav-container">
        {SUB_MENU_ORDER.map((step, index) => {

          const isClickable = index <= maxStepReached;

          return (
            <button
              key={step}
              type="button"
              className={`btn-interactive subnav-link ${activeSubMenu === step ? "active" : ""}`}
              disabled={!isClickable}
              onClick={() => {
                if (isClickable) {
                  setActiveSubMenu(step);
                }
              }}
              style={{
                cursor: isClickable ? "pointer" : "not-allowed",
                opacity: isClickable ? 1 : 0.5
              }}
            >
              {step.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
            </button>
          );
        })}
      </div>

      {activeSubMenu === "personalDetails" && (
        <div className="join-main">
          <form
            className="join-form join-containers"
            onSubmit={handleSubmit(onSubmit)}
          >
            <label htmlFor="fullName" className="join-label">
              Full Name <span className="star">*</span>
            </label>
            <input id="fullName"
              value={userName || ""}
              className="join-input"
              type="text"
              placeholder="Enter your name"
              readOnly
              disabled
            />
            {errors.fullName && (
              <p className="error-msg">{errors.fullName.message}</p>
            )}
            <label htmlFor="religion" className="join-label">
              Religion <span className="star">*</span>
            </label>

            <input
              id="religion"
              type="text"
              placeholder={errors.religion ? "Religion is required" : "Enter your religion"}
              {...register("religion", {
                required: "Religion is required",
                validate: (value) => {
                  if (!/^[A-Za-z\s]+$/.test(value)) {
                    return "Numbers and special characters are not allowed";
                  }
                  if (value.length < 2) {
                    return "Please enter at least 2 characters";
                  }
                  return true;
                },
                maxLength: {
                  value: 50,
                  message: "Cannot exceed 50 characters",
                },
              })}
              className={`join-input ${errors.religion ? "invalid" : ""}`}
              maxLength={50}
            />

            {errors.religion && (
              <p className="error-msg">{errors.religion.message}</p>
            )}
            <label htmlFor="bloodGrp" className="join-label">
              Blood Group <span className="star">*</span>
            </label>
            <select id="bloodGrp"
              {...register("bloodGroup", {
                required: true,
              })}
              className={`join-input form-control selectBloodGroupInput ${errors.bloodGroup ? "invalid" : ""}`}
            >
              <option value="" hidden>
                {errors.bloodGroup
                  ? "⚠ Blood Group is required"
                  : "Select Blood Group"}
              </option>
              <option value="A+">A+</option>
              <option value="A-">A-</option>
              <option value="B+">B+</option>
              <option value="B-">B-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>
              <option value="O+">O+</option>
              <option value="O-">O-</option>
            </select>
            {errors.bloodGroup && (
              <p className="error-msg">{errors.bloodGroup.message}</p>
            )}
            <label htmlFor="marital" className="join-label">
              Marital Status <span className="star">*</span>
            </label>
            <select
              id="marital"
              value={watch("maritalStatus") || ""}
              {...register("maritalStatus", { required: "Marital Status is required" })}
              className={`join-input form-control selectBloodGroupInput ${errors.maritalStatus ? "invalid" : ""}`}
              onChange={(e) => {
                setValue("maritalStatus", e.target.value);
                trigger("maritalStatus");
              }}
            >
              <option value="" hidden>
                {errors.maritalStatus ? "⚠ Marital Status is required" : "Select Marital Status"}
              </option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
              <option value="Divorced">Divorced</option>
              <option value="Widowed">Widowed</option>
              <option value="Separated">Separated</option>
              <option value="Single parent">Single parent</option>
              <option value="Prefer not to say">Prefer not to say</option>
            </select>
            <div className="form-field">
              <label className="field-label mb-0">
                Employment of Spouse
              </label>
              <div className="radio-group">
                <label htmlFor="spouseYes">
                  <input
                    id="spouseYes"
                    type="radio"
                    value="Yes"
                    {...register("employmentOfSpouse")}
                  />
                  Yes
                </label>
                <label htmlFor="spouseNo">
                  <input
                    id="spouseNo"
                    type="radio"
                    value="No"
                    {...register("employmentOfSpouse")}
                  />
                  No
                </label>
              </div>
            </div>
            <label htmlFor="emergencyNo" className="join-label">
              Emergency Contact Number
            </label>
            <input id="emergencyNo"
              className={`join-input ${errors.emergencyContactNumber ? "invalid" : ""}`}
              type="text"
              placeholder={
                errors.emergencyContactNumber
                  ? "⚠ Emergency contact number is required"
                  : "Enter emergency contact number"
              }
              {...register("emergencyContactNumber", {
                pattern: {
                  value: /^[6-9]\d{9}$/,
                  message: "Invalid Number! Must start with 6,7,8,or 9",
                },
                minLength: {
                  value: 10,
                  message: "Only Numbres are Allowed",
                },
                maxLength: {
                  value: 10,
                  message: "10 digits completed",
                },
              })}
              maxLength={10}
            />
            {errors.emergencyContactNumber && (
              <p className="error-msg">
                {errors.emergencyContactNumber.message}
              </p>
            )}
            <div className="button-container">
              <button
                className="primary-btn"
                type="button"
                onClick={handleStepSubmit}
              >
                Save and Next
              </button>
            </div>
          </form>
        </div>
      )}
      {activeSubMenu === "nomineeDetails" && (
        <div className="join-main">
          <div className="join-containers">
            <ToggleCTA
              label="Nominee Details"
              subText="Have a nominee to add? Keep this on. Otherwise, turn it off to skip."
              checked={hasNominee}
              onChange={setHasNominee}
              isExistingEmp={isExistingEmp}
            />
            {hasNominee ? (
              <form className="join-form" onSubmit={handleSubmit(onSubmit)}>
                <label htmlFor="nomineeName" className="join-label">
                  Nominee Name <span className="star">*</span>
                </label>
                <input id="nomineeName"
                  type="text"
                  placeholder={
                    errors.nomineeName
                      ? "⚠ Name is required "
                      : "Enter nominee name"
                  }
                  {...register("nomineeName", {
                    required: "Name is required",
                    validate: (value) => {
                      if (!/^[A-Za-z\s]+$/.test(value)) {
                        return "Numbers and special characters are not allowed";
                      }
                      if (value.length < 2) {
                        return "Please enter at least 2 characters";
                      }
                      return true;
                    },
                    maxLength: {
                      value: 50,
                      message: "Maximum 50 characters allowed",
                    },
                  })}
                  className={`join-input ${errors.nomineeName ? "invalid" : ""}`}
                  maxLength={51}
                />
                {errors.nomineeName && (
                  <p className="error-msg"> {errors.nomineeName.message} </p>
                )}
                <label htmlFor="nomineeRelation" className="join-label">
                  Relation <span className="star">*</span>
                </label>
                <input id="nomineeRelation"
                  type="text"
                  placeholder={
                    errors.relation ? "⚠ Relation is required" : "Enter relation"
                  }
                  {...register("relation", {
                    required: "Relation is required",
                    validate: (value) => {
                      if (!/^[A-Za-z\s]+$/.test(value)) {
                        return "Numbers and special characters are not allowed";
                      }
                      if (value.length < 2) {
                        return "Please enter at least 2 characters";
                      }
                      return true;
                    },
                    maxLength: {
                      value: 30,
                      message: "Maximum 30 characters allowed",
                    },
                  })}
                  className={`join-input ${errors.relation ? "invalid" : ""}`}
                  maxLength={30}
                />
                {errors.relation && (
                  <p className="error-msg">{errors.relation.message}</p>
                )}
                <label htmlFor="nomineeDob" className="join-label">
                  DOB <span className="star">*</span>
                </label>
                <input id="nomineeDob"
                  className={`join-input ${errors.dob ? "invalid" : ""}`}
                  type="date"
                  max={today}
                  {...register("dob", {
                    required: "DOB is required",
                    validate: (value) => new Date(value) <= new Date() || "Future dates are not allowed"
                  })}
                  onFocus={(e) => (e.target.type = "date")}
                  onBlur={(e) => {
                    if (!e.target.value && errors.dob) {
                      e.target.type = "text";
                    }
                  }}
                />
                {errors.dob && <p className="error-msg">{errors.dob.message}</p>}
                <label htmlFor="nomineeAddress" className="join-label">
                  Address <span className="star">*</span>
                </label>
                <input id="nomineeAddress"
                  type="text"
                  className={`join-input ${errors.address ? "invalid" : ""}`}
                  placeholder={
                    errors.address ? "⚠ Address is required" : "Enter address"
                  }
                  maxLength="100"
                  {...register("address", {
                    required: true,
                    minLength: {
                      value: 5,
                      message: "Address is too short (min 5 characters)",
                    },
                    maxLength: {
                      value: 100,
                      message: "100 characters completed",
                    },
                    pattern: {
                      value: /^[A-Za-z0-9\s,./-]+$/,
                      message:
                        "Only letters, numbers, and ( , / - . ) are allowed",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replaceAll(
                      /[^A-Za-z0-9\s,./-]/g,
                      "",
                    );
                  }}
                />
                {errors.address && (
                  <p className="error-msg">{errors.address.message}</p>
                )}
                <label htmlFor="nomineeAadhaar" className="join-label">
                  Aadhaar Card Number (<small>Please provide a valid Aadhaar number and upload a clear copy</small>) <span className="star">*</span>
                </label>
                <div className={`combined-input-box ${errors.aadhaarCardNumber ? "invalid-border" : ""}`} >
                  <input id="nomineeAadhaar"
                    className={`join-input-aadhaar ${errors.aadhaarCardNumber ? "error-text" : ""}`}
                    type="text"
                    placeholder={
                      errors.aadhaarCardNumber
                        ? "⚠ Please provide a valid Aadhaar number and upload a clear copy"
                        : "1234-5678-9012"
                    }
                    maxLength="14"
                    {...register("aadhaarCardNumber", {
                      required: true,
                      pattern: {
                        value: /^\d{4}-\d{4}-\d{4}$/,
                        message:
                          "Aadhaar number must be in 1234-5678-9012 format",
                      },
                    })}
                    onInput={(e) => {
                      let val = e.target.value.replaceAll(/\D/g, "");
                      let formatted = "";
                      for (let i = 0; i < val.length && i < 12; i++) {
                        if (i > 0 && i % 4 === 0) {
                          formatted += "-";
                        }
                        formatted += val[i];
                      }
                      e.target.value = formatted;
                    }}
                  />
                  <button type="button"
                    onClick={() => aadhaarFileRef.current.click()}
                    title="Upload Aadhaar Document"
                    className="btn-interactive upload-btn"
                  >
                    <span className="upload-icon">
                      <i className="bi bi-box-arrow-up"></i>
                    </span>
                  </button>

                  <Controller
                    name="nomineeAadhaarCard"
                    control={control}
                    rules={{
                      required: !hasAadhaarCard ? "Aadhaar document is required" : false,
                      validate: (files) =>
                        ValidateFile(files, ["application/pdf", "image/jpeg", "image/jpg", "image/png"]),
                    }}
                    render={({ field }) => (
                      <input
                        type="file"
                        ref={aadhaarFileRef}
                        style={{ display: "none" }}
                        accept=".jpg,.jpeg,.png,.pdf"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          field.onChange(file);
                          handleFileSelect("nomineeAadhaarCard", file);
                          if (errors.nomineeAadhaarCard?.type === "manual") {
                            clearErrors("nomineeAadhaarCard");
                          }
                        }}
                      />
                    )}
                  />
                </div>
                <div className="d-flex align-items-space-between">
                  {selectedFiles.nomineeAadhaarCard && uploadStatus['nomineeAadhaarCard'] !== "succeeded" && (
                    <div>
                      {selectedFiles.nomineeAadhaarCard.name}
                    </div>
                  )}
                  {(selectedFiles.nomineeAadhaarCard && uploadStatus['nomineeAadhaarCard'] !== "succeeded") && (<button
                    type="button"
                    className="upload-file-btn"
                    disabled={!selectedFiles.nomineeAadhaarCard ||
                      (errors.nomineeAadhaarCard && errors.nomineeAadhaarCard.type === "validate")}
                    onClick={() => handleFileUpload('nomineeAadhaarCard')}
                  >
                    {uploadStatus['nomineeAadhaarCard'] === "loading" ?
                      "Uploading..." :
                      "Upload"
                    }
                  </button>
                  )}
                  {(uploadStatus['nomineeAadhaarCard'] === "succeeded" || hasAadhaarCard) && (<button
                    type="button"
                    className="view-btn"
                    onClick={() => handleViewFile('nomineeAadhaarCard')}
                  >
                    View uploaded Aadhar Card
                  </button>
                  )}
                </div>

                {errors.aadhaarCardNumber && (
                  <p className="error-msg">{errors.aadhaarCardNumber.message}</p>
                )}
                {errors.nomineeAadhaarCard && (<p className="error-msg">{errors.nomineeAadhaarCard.message}</p>
                )}
                <label htmlFor="nomineePan" className="join-label">
                  PAN Card Number (<small>Please provide a valid PAN number and upload a clear copy</small>) <span className="star">*</span>
                </label>
                <div className={`combined-input-box ${errors.panCardNumber ? "invalid-border" : ""}`}>
                  <input id="nomineePan"
                    className={`join-input-aadhaar ${errors.panCardNumber ? "error-text" : ""}`}
                    type="text"
                    placeholder={
                      errors.panCardNumber
                        ? "⚠ Please provide a valid PAN number and upload a clear copy"
                        : "Enter PAN Card Number"
                    }
                    maxLength="10"
                    {...register("panCardNumber", {
                      required: true,
                      pattern: {
                        value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                        message: "Invalid PAN format (ABCDE1234F)",
                      },
                      maxLength: {
                        value: 10,
                        message: "10 characters completed",
                      },
                    })}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .toUpperCase()
                        .replaceAll(/[^A-Z\d]/g, "")
                        .trim();
                    }}
                  />
                  <button type="button"
                    onClick={() => panFileRef.current.click()}
                    title="Upload PAN Card Document"
                    className="btn-interactive upload-btn"
                  >
                    <span className="upload-icon">
                      <i className="bi bi-box-arrow-up"></i>
                    </span>
                  </button>
                  <Controller
                    name="nomineePanCard"
                    control={control}
                    rules={{
                      required: !hasPanCard ? "Pan document is required" : false,
                      validate: (files) =>
                        ValidateFile(files, ["application/pdf", "image/jpeg", "image/jpg", "image/png"]),
                    }}
                    render={({ field }) => (
                      <input
                        type="file"
                        ref={panFileRef}
                        style={{ display: "none" }}
                        accept=".jpg,.jpeg,.png,.pdf"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          field.onChange(file);
                          handleFileSelect("nomineePanCard", file);
                          if (errors.nomineePanCard?.type === "manual") {
                            clearErrors("nomineePanCard");
                          }
                        }}
                      />
                    )}
                  />
                </div>
                <div className="d-flex align-items-space-between">
                  {selectedFiles.nomineePanCard && uploadStatus['nomineePanCard'] !== "succeeded" && (
                    <div>
                      {selectedFiles.nomineePanCard.name}
                    </div>
                  )}
                  {(selectedFiles.nomineePanCard && uploadStatus['nomineePanCard'] !== "succeeded") && (<button
                    type="button"
                    className="upload-file-btn"
                    disabled={!selectedFiles.nomineePanCard ||
                      (errors.nomineePanCard && errors.nomineePanCard.type === "validate")}
                    onClick={() => handleFileUpload('nomineePanCard')}
                  >
                    {uploadStatus['nomineePanCard'] === "loading" ?
                      "Uploading..." :
                      "Upload"
                    }
                  </button>
                  )}
                  {(uploadStatus['nomineePanCard'] === "succeeded" || hasPanCard) && (<button
                    type="button"
                    className="view-btn"
                    onClick={() => handleViewFile('nomineePanCard')}
                  >
                    View uploaded Pan Card
                  </button>
                  )}
                </div>
                {errors.panCardNumber && (
                  <p className="error-msg"> {errors.panCardNumber.message} </p>
                )}
                {errors.nomineePanCard && (
                  <p className="error-msg"> {errors.nomineePanCard.message} </p>
                )}
                <div className="button-container">
                  <button
                    className="primary-btn"
                    type="button"
                    onClick={handleStepSubmit}
                  >
                    Save and Next
                  </button>
                </div>
              </form>
            ) : (
              <div className="button-container">
                <button
                  className="primary-btn"
                  type="button"
                  onClick={() => {
                    dispatch(goNext());
                    setActiveSubMenu("insuranceDependentDetails");
                  }}
                >
                  Skip and Next
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {activeSubMenu === "insuranceDependentDetails" && (
        <div className="table-container">

          <ToggleCTA
            label="Family / Insurance Details"
            subText="Adding family members for insurance? Keep this on. Otherwise, turn it off to skip."
            checked={hasInsurance}
            onChange={setHasInsurance}
            isExistingEmp={isExistingEmp}
          />
          {hasInsurance ? (<>
            {/* <button className="primary-btn my-2 pl-4 pr-4" title="export data"
              onClick={handleExport}
            >
              Export
            </button> */}
            {/* <h5 className="mb-2 ml-3" style={{ fontWeight: 'bold' }}>Family Information (<small>Used for Medical Insurance</small>)</h5> */}
            <form className="table-main" onSubmit={handleSubmit(onSubmit)}>
              <table className="user-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ width: "250px"}}>
                      Name <span className="star">*</span>
                    </th>
                    <th>
                      Relationship <span className="star">*</span>
                    </th>
                    <th>
                      Date Of Birth <span className="star">*</span>
                    </th>
                    <th>
                      Gender <span className="star">*</span>
                    </th>
                   <th style={{ width: "110px"}}>
                      Age <span className="star">*</span>
                    </th>
                    <th>
                      Phone
                    </th>
                    <th>
                      SI Amount <span className="star">*</span>
                    </th>
                    <th style={{ width: "100px"}} className="action-cell">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {inputList.map((x, i) => (
                    <tr key={i}>
                      <td>
                        <input
                          type="text"
                          className={`join-input ${errors.insuranceDependentDetails?.[i]?.name ? "invalid" : ""}`}
                          placeholder={
                            errors.insuranceDependentDetails?.[i]?.name
                              ? "⚠ Name is required"
                              : "Enter name"
                          }
                          {...register(`insuranceDependentDetails.${i}.name`, {
                            required: true,
                            maxLength: {
                              value: 30,
                              message: "Maximum 30 characters allowed",
                            },
                            minLength: {
                              value: 2,
                              message: "Minimum 2 characters required",
                            },
                            pattern: {
                              value: /^[A-Za-z\s]+$/,
                              message: "Only alphabets are allowed",
                            },
                          })}
                          maxLength={31}
                        />
                        {errors.insuranceDependentDetails?.[i]?.name && (
                          <p className="error-msg">
                            {errors.insuranceDependentDetails[i].name.message}
                          </p>
                        )}
                      </td>
                      <td>                       
                        <select className={`join-input ${errors.insuranceDependentDetails?.[i]?.relationship ? "invalid" : ""}`}
                          {...register(`insuranceDependentDetails.${i}.relationship`, {
                            required: "Relationship is required",
                          })}
                        >
                          <option value="">Select relationship</option>
                          <option value="Father" disabled={hasInLaw}>Father</option>
                          <option value="Mother" disabled={hasInLaw}>Mother</option>
                          <option value="Spouse">Spouse</option>
                          <option value="Son">Son</option>
                          <option value="Daughter">Daughter</option>
                          <option value="Father in law" disabled={hasParent}>
                            Father in law
                          </option>
                          <option value="Mother in law" disabled={hasParent}>
                            Mother in law
                          </option>
                        </select>
                      </td>
                      <td>                       
                        <input type="date" max={today} className={`join-input ${errors.insuranceDependentDetails?.[i]?.dob ? "invalid" : "" }`}
                          {...register(`insuranceDependentDetails.${i}.dob`, {
                            required: "dob is required",
                            validate: (value) =>
                              new Date(value) <= new Date() ||
                              "Future dates are not allowed",
                            onChange: (e) => {
                              const dob = e.target.value;
                              const birthDate = new Date(dob);
                              const todayDate = new Date();
                              let age = todayDate.getFullYear() - birthDate.getFullYear();
                              const monthDiff = todayDate.getMonth() - birthDate.getMonth();
                              if (
                                monthDiff < 0 ||
                                (monthDiff === 0 &&
                                  todayDate.getDate() < birthDate.getDate())
                              ) {
                                age--;
                              }
                              setValue(`insuranceDependentDetails.${i}.age`, age);
                            },
                          })}
                        />
                      </td>
                      <td>
                        <select
                          className={`join-input ${errors.insuranceDependentDetails?.[i]?.gender ? "invalid" : ""
                            }`}
                          {...register(`insuranceDependentDetails.${i}.gender`, {
                            required: "Gender is required",
                          })}
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">
                            Male
                          </option>
                          <option value="Female">
                            Female
                          </option>
                          <option value="Other">
                            Other
                          </option>
                        </select>
                      </td>
                      <td>
                        <input
                          className={`join-input ${errors.insuranceDependentDetails?.[i]?.age ? "invalid" : ""
                            }`}
                          type="text"
                          placeholder={
                            errors.insuranceDependentDetails?.[i]?.age
                              ? "⚠ Age is required"
                              : "Enter age"
                          }
                          {...register(`insuranceDependentDetails.${i}.age`, {
                            required: true,
                            maxLength: {
                              value: 3,
                              message: "Age cannot exceed 3 digits",
                            },
                          })}
                          maxLength={3}
                          readOnly disabled
                        />
                        {errors.insuranceDependentDetails?.[i]?.age && (
                          <p className="error-msg">
                            {errors.insuranceDependentDetails[i].age.message}
                          </p>
                        )}
                      </td>
                      <td>
                        <input
                          className={`join-input ${errors.insuranceDependentDetails?.[i]?.phone ? "invalid" : ""}`}
                          type="text"
                          placeholder={
                            "Enter phone number"
                          }
                          {...register(`insuranceDependentDetails.${i}.phone`, {

                            maxLength: {
                              value: 10,
                              message: "Phone number must be 10 digits",
                            },
                            minLength: {
                              value: 10,
                              message: "Only Numbers are Allowed",
                            },
                            pattern: {
                              value: /^[6-9]\d{9}$/,
                              message:
                                "Invalid Number! Must start with 6,7,8,or 9",
                            },
                          })}
                          maxLength={10}
                        />
                        {errors.insuranceDependentDetails?.[i]?.phone && (
                          <p className="error-msg">
                            {errors.insuranceDependentDetails[i].phone.message}
                          </p>
                        )}
                      </td>
                      <td>
                        <select
                          className={`join-input ${errors.insuranceDependentDetails?.[i]?.amount ? "invalid" : ""}`}
                          {...register(`insuranceDependentDetails.${i}.amount`, {
                            required: "SI Amount is required",
                          })}
                        >
                          <option value="">Select Amount</option>
                          <option value="500000">500000</option>
                          <option value="1000000" >1000000</option>
                        </select>
                      </td>
                      <td>
                        <div className="form-buttons">
                          {inputList.length > 1 && (
                            <button
                              type="button"
                              className="icon-only-button"
                              onClick={() => handleRemove(i)}
                            >
                              <i className="bi bi-dash-circle"></i>
                            </button>
                          )}
                          {inputList.length - 1 === i && (
                            <button
                              type="button"
                              onClick={handleAddClick}
                              className="icon-only-button"
                            >
                              <i className="bi bi-plus-circle"></i>
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="button-container">
                <button className="primary-btn" type="button" onClick={handleStepSubmit}>
                  Save and Next
                </button>
              </div>
            </form>
          </>) : (
            <div className="button-container">
              <button
                className="primary-btn"
                type="button"
                onClick={() => {
                  dispatch(goNext());
                  setActiveSubMenu("bankDetails");
                }}
              >
                Skip and Next
              </button>
            </div>
          )}
        </div>
      )}
      {activeSubMenu === "bankDetails" && (
        isExistingEmp ? (
          <div className="join-main">
            <div className="join-containers">
              <ToggleCTAExisting
                label="Bank Details"
                subText="Should there be any discrepancy in your bank details, kindly contact HR and open a support ticket"
                checked={true}
                onChange={setHasBank}
                isExistingEmp={isExistingEmp}
              />

              <form className="join-form" onSubmit={handleSubmit(onSubmit)}>
                <label htmlFor="bankName" className="join-label">
                  Bank Name <span className="star">*</span>
                </label>
                <div id="bankName"
                  className={`join-input  bg-light text-muted opacity-100`}

                >{bankDetails?.bankName ?? "N/A"}</div>
                <label htmlFor="branchName" className="join-label">
                  Branch Name <span className="star">*</span>
                </label>
                <div id="branchName"
                  className={`join-input  bg-light text-muted opacity-100`}
                >{bankDetails?.branchName ?? "N/A"}</div>

                <label htmlFor="accountNo" className="join-label">
                  Account Number <span className="star">*</span>
                </label>
                <div id="accountNo"
                  className={`join-input  bg-light text-muted opacity-100`}
                >
                  {bankDetails?.accountNumber ?? "N/A"}
                </div>
                <label htmlFor="ifscCode" className="join-label">
                  IFSC Code <span className="star">*</span>
                </label>
                <div id="ifscCode" className={`join-input  bg-light text-muted opacity-100`}>
                  {bankDetails?.ifscCode ?? "N/A"}
                </div>

                <label htmlFor="accountHolderName" className="join-label">
                  Account Holder Name <span className="star">*</span>
                </label>
                <div id="accountHolderName"
                  className={`join-input  bg-light text-muted opacity-100`}
                >
                  {bankDetails?.accountHolderName ?? "N/A"}
                </div>
                <div className="button-container">
                  <button
                    className="primary-btn"
                    type="button"
                    onClick={() => {
                      const payload = {
                        bankDetails: {
                          bankName: bankDetails.bankName,
                          branchName: bankDetails.branchName,
                          accountNumber: bankDetails.accountNumber,
                          ifscCode: bankDetails.ifscCode,
                          accountHolderName: bankDetails.accountHolderName,
                        }
                      };
                      dispatch(updateJoiningDetails({ userId, payload }));
                      dispatch(setActiveMenu({ menu: 'uploaddocuments', subMenu: "summary" }));
                    }}
                  >
                    Save and Complete
                  </button>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <div className="join-main">
            <div className="join-containers">
              <ToggleCTA
                label="Bank Details"
                subText="Want to add your bank details now? Keep this on. Or turn it off to skip for now."
                checked={hasBank}
                onChange={setHasBank}
                isExistingEmp={isExistingEmp}
              />
              {hasBank ? (
                <form className="join-form" onSubmit={handleSubmit(onSubmit)}>
                  <label htmlFor="bankName" className="join-label">
                    Bank Name <span className="star">*</span>
                  </label>
                  <input id="bankName"
                    type="text"
                    placeholder={
                      errors.bankName
                        ? "⚠  BankName is required "
                        : "Enter bank name"
                    }
                    {...register("bankName", {
                      required: true,
                      maxLength: {
                        value: 30,
                        message: "Maximum 30 characters allowed",
                      },
                      minLength: {
                        value: 3,
                        message: "Minimum 3 characters required",
                      },
                      pattern: {
                        value: /^[A-Za-z\s]+$/,
                        message: "Only alphabets are allowed",
                      },
                    })}
                    className={`join-input ${errors.bankName ? "invalid" : ""}`}
                    maxLength={31}
                  />
                  {errors.bankName && (
                    <p className="error-msg"> {errors.bankName.message} </p>
                  )}
                  <label htmlFor="branchName" className="join-label">
                    Branch Name <span className="star">*</span>
                  </label>
                  <input id="branchName"
                    type="text"
                    placeholder={
                      errors.bankName
                        ? "⚠  BankName is required "
                        : "Enter bank name"
                    }
                    {...register("branchName", {
                      required: true,
                      minLength: {
                        value: 3,
                        message: "Minimum 3 characters required",
                      },
                      maxLength: {
                        value: 30,
                        message: "Maximum 30 characters allowed",
                      },
                      pattern: {
                        value: /^[A-Za-z0-9\s\-&.]+$/,
                        message:
                          "Only letters, numbers, spaces and (-, &, .) are allowed",
                      },
                    })}
                    className={`join-input ${errors.branchName ? "invalid" : ""}`}
                    maxLength={31}
                  />
                  {errors.branchName && (
                    <p className="error-msg"> {errors.branchName.message} </p>
                  )}
                  <label htmlFor="accountNo" className="join-label">
                    Account Number <span className="star">*</span>
                  </label>
                  <input id="accountNo"
                    type="text"
                    placeholder={
                      errors.accountNumber
                        ? "⚠ Account Number is required"
                        : "Enter account number"
                    }
                    {...register("accountNumber", {
                      required: true,
                      pattern: {
                        value: /^\d*$/,
                        message: "Only numbers are allowed",
                      },
                      minLength: {
                        value: 9,
                        message: "Minimum 9 digits required",
                      },
                      maxLength: {
                        value: 18,
                        message: "Maximum 18 digits allowed",
                      },
                    })}
                    className={`join-input ${errors.accountNumber ? "invalid" : ""}`}
                    maxLength={19}
                  />

                  {errors.accountNumber && (
                    <p className="error-msg">{errors.accountNumber.message}</p>
                  )}
                  <label htmlFor="ifscCode" className="join-label">
                    IFSC Code <span className="star">*</span>
                  </label>
                  <input id="ifscCode"
                    className={`join-input ${errors.ifscCode ? "invalid" : ""}`}
                    type="text"
                    placeholder={
                      errors.ifscCode
                        ? "⚠ IFSC Code is required"
                        : "Enter IFSC code"
                    }
                    maxLength="11"
                    {...register("ifscCode", {
                      required: true,
                      pattern: {
                        value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                        message: "Invalid IFSC format (e.g., SBIN0001234)",
                      },
                      minLength: {
                        value: 11,
                        message: "IFSC code must be exactly 11 characters",
                      },
                    })}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .toUpperCase()
                        .replaceAll(/[^A-Z0-9]/g, "")
                        .trim();
                    }}
                  />
                  {errors.ifscCode && (
                    <p className="error-msg">{errors.ifscCode.message}</p>
                  )}
                  <label htmlFor="accountHolderName" className="join-label">
                    Account Holder Name <span className="star">*</span>
                  </label>
                  <input id="accountHolderName"
                    type="text"
                    className={`join-input ${errors.accountHolderName ? "invalid" : ""}`}
                    placeholder={
                      errors.accountHolderName
                        ? "⚠ Account Holder Name is required"
                        : "Enter account holder name"
                    }
                    {...register("accountHolderName", {
                      required: true,
                      minLength: {
                        value: 2,
                        message: "Minimum 2 characters required",
                      },
                      maxLength: {
                        value: 30,
                        message: "Maximum 30 characters allowed",
                      },
                      pattern: {
                        value: /^[A-Za-z\s]*$/,
                        message: "Only alphabets are allowed",
                      },
                    })}
                    maxLength={31}
                  />

                  {errors.accountHolderName && (
                    <p className="error-msg">{errors.accountHolderName.message}</p>
                  )}
                  <label htmlFor="passbookFrontImg" className="join-label">
                    Upload Passbook Front Image <span className="star">*</span>
                  </label>
                  <div className="input-upload-btn-container">
                    <input
                      id="passbookFrontImg"
                      className={`join-input ${errors.passbookFrontImage ? "invalid" : ""}`}
                      placeholder={
                        errors.passbookFrontImage
                          ? "⚠ Passbook Front Image is required"
                          : "Upload Passbook Front Image"
                      }
                      type="file"
                      accept=".jpg, .jpeg, .png"
                      style={{ marginRight: "8px" }}
                      {...passbookReg}
                      onChange={async (e) => {
                        const newFile = e.target.files[0];
                        if (!newFile) {
                          if (selectedFiles && selectedFiles.passbookFrontImage) {
                            const dataTransfer = new DataTransfer();
                            dataTransfer.items.add(selectedFiles.passbookFrontImage);
                            e.target.files = dataTransfer.files;
                          }
                          return;
                        }

                        await passbookReg.onChange(e);
                        trigger("passbookFrontImage");
                        handleFileSelect("passbookFrontImage", newFile);

                        if (errors.passbookFrontImage?.type === "manual") {
                          clearErrors("passbookFrontImage");
                        }
                      }}
                    />
                    {selectedFiles.passbookFrontImage &&
                      uploadStatus["passbookFrontImage"] !== "succeeded" && (
                        <button
                          type="button"
                          className="upload-file-btn"
                          disabled={
                            !selectedFiles.passbookFrontImage ||
                            uploadStatus["passbookFrontImage"] === "succeeded" ||
                            (errors.passbookFrontImage && errors.passbookFrontImage.type === "validate")
                          }
                          onClick={() => handleFileUpload("passbookFrontImage")}
                        >
                          {uploadStatus["passbookFrontImage"] === "loading"
                            ? "Uploading..."
                            : "Upload"}
                        </button>
                      )}
                  </div>
                  {(uploadStatus["passbookFrontImage"] === "succeeded" || hasPassbookFrontImage) && (
                    <button
                      type="button"
                      className="view-btn"
                      onClick={() => handleViewFile("passbookFrontImage")}
                    >
                      View uploaded Passbook Front Image
                    </button>
                  )}
                  {errors.passbookFrontImage && (
                    <p className="error-msg">{errors.passbookFrontImage.message}</p>
                  )}
                  <label htmlFor="cancelledCheque" className="join-label">
                    Upload Cancelled Cheque<span className="star">*</span>
                  </label>
                  <div className="input-upload-btn-container">
                    <input id="cancelledCheque"
                      className={`join-input ${errors.cancelledCheque ? "invalid" : ""}`}
                      placeholder={
                        errors.cancelledCheque
                          ? "⚠ Cancelled Cheque is required"
                          : "Upload Cancelled Cheque"
                      }
                      type="file"
                      accept=".jpg, .jpeg, .png"
                      style={{ marginRight: "8px" }}
                      {...cancelledChequeReg}
                      onChange={async (e) => {
                        const newFile = e.target.files[0];
                        if (!newFile) {
                          if (selectedFiles && selectedFiles.cancelledCheque) {
                            const dataTransfer = new DataTransfer();
                            dataTransfer.items.add(selectedFiles.cancelledCheque);
                            e.target.files = dataTransfer.files;
                          }
                          return;
                        }
                        await cancelledChequeReg.onChange(e);
                        trigger("cancelledCheque");
                        handleFileSelect("cancelledCheque", newFile);
                        if (errors.cancelledCheque?.type === "manual") {
                          clearErrors("cancelledCheque");
                        }
                      }}
                    />
                    {selectedFiles.cancelledCheque &&
                      uploadStatus["cancelledCheque"] !== "succeeded" && (
                        <button
                          type="button"
                          className="upload-file-btn"
                          disabled={
                            !selectedFiles.cancelledCheque ||
                            uploadStatus["cancelledCheque"] === "succeeded" ||
                            (errors.cancelledCheque && errors.cancelledCheque.type === "validate")
                          }
                          onClick={() => handleFileUpload("cancelledCheque")}
                        >
                          {uploadStatus["cancelledCheque"] === "loading"
                            ? "Uploading..."
                            : "Upload"}
                        </button>
                      )}
                  </div>
                  {(uploadStatus["cancelledCheque"] === "succeeded" || hasCancelledCheque) && (
                    <button
                      type="button"
                      className="view-btn"
                      onClick={() => handleViewFile("cancelledCheque")}
                    >
                      View uploaded cancelled Cheque
                    </button>
                  )}
                  {errors.cancelledCheque && (
                    <p className="error-msg">{errors.cancelledCheque.message}</p>
                  )}
                  <div className="button-container">
                    <button
                      className="primary-btn"
                      type="button"
                      onClick={handleStepSubmit}
                    >
                      Save and Complete
                    </button>
                  </div>
                </form>
              ) : (
                <div className="button-container">
                  <button
                    className="primary-btn"
                    type="button"
                    onClick={() => {
                      const payload = {
                        bankDetails: {
                          bankSkip: true,
                        }
                      };
                      dispatch(updateJoiningDetails({ userId, payload }));
                      if (isExistingEmp) {
                        dispatch(setActiveMenu({ menu: 'uploaddocuments', subMenu: "summary" }));
                      }
                      else {
                        dispatch(setActiveMenu({ menu: 'policies', subMenu: "summary" }));
                      }
                    }}
                  >
                    Save and Complete
                  </button>
                </div>
              )}
            </div>
          </div>)
      )}
      <ToastContainer />
    </div>
  );
};
export default JoiningDetailsForm;
